import type { SpuSkuGroupSearchDTO } from '@/services/api/goods/type'
import { createSlice } from '@reduxjs/toolkit'
import { cloneDeep } from 'lodash'

const initialState = {
  autoSearchList: null,
  needRowCheck: false,
  //TODO: 优化自动搜索用的
  // autoSearchInfo:null
  /**商品信息缓存，skuid为key，商品信息为value，以页面生命周期进行销毁 */
  goodsCacheMap: {} as Record<string, SpuSkuGroupSearchDTO>,
}
/**
 * 商品管理批量更新的自动搜索
 */
const goodsSlice = createSlice({
  name: 'goodsSlice',
  initialState: initialState,
  reducers: {
    /**
     * TODO: 分开会导致触发search2次
     */
    setAutoSearchList(state, action) {
      return {
        ...state,
        autoSearchList: action.payload,
      }
    },
    /**
     * TODO: 与上面分开会导致触发search2次
     */
    setNeedRowCheck(state, action) {
      return {
        ...state,
        needRowCheck: action.payload,
      }
    },
    //TODO: 优化自动搜索用的
    // setAutoSearchInfo(state, action) {
    //   return {
    //     ...state,
    //     autoSearchInfo: {
    //       ...state.autoSearchInfo,
    //       ...action.payload
    //     }
    //   }
    // }
    addToGoodsCacheMap(state, action: { payload: SpuSkuGroupSearchDTO[] }) {
      const { goodsCacheMap } = state
      const newGoodsCacheMap = { ...goodsCacheMap }
      action.payload?.forEach((g) => {
        newGoodsCacheMap[g.skuId] = cloneDeep(g)
      })
      return { ...state, goodsCacheMap: newGoodsCacheMap }
    },
    clearGoodsCacheMap(state) {
      return { ...state, goodsCacheMap: {} }
    },
  },
})

export const { setAutoSearchList, setNeedRowCheck, addToGoodsCacheMap, clearGoodsCacheMap } = goodsSlice.actions
export default goodsSlice.reducer
